export default __webpack_public_path__ + "assets/2259b7ae4762f94fded573d7874da7fd.png";